// customMessageEnums


export default {
	'welcomeEmail': 61,
	'welcomeText': 191,
	'thankYouEmail': 31
}
